import { SimpleCoordinates } from './simplecoordinates';

export class BoundingBox {
  northEast: SimpleCoordinates;
  southWest: SimpleCoordinates;
}
